import { Link } from 'react-router-dom';

const ForbiddenError = () => {
    return (
        <div className="d-flex align-items-center justify-content-center vh-100">
            <div className="text-center">
                <h1 className="display-1 fw-bold mb-3">403</h1>
                <p className="fs-3 mb-3">
                    <span className="text-danger">Opps!</span> Forbidden.
                </p>
                <p className="lead mb-3">이 리소스에 액세스 할 수있는 권한이 없습니다.</p>
                <Link to="/login" className="btn btn-primary">
                    홈으로 이동
                </Link>
            </div>
        </div>
    );
};

export default ForbiddenError;
